import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=152e7998&scoped=true&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=152e7998&prod&scoped=true&lang=scss&"
import style1 from "./ProductCard.vue?vue&type=style&index=1&id=152e7998&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152e7998",
  null
  
)

export default component.exports